import { RListsHttp } from '@rhybus/api'

import { apiPath, fetchProvider } from './api'

/**rhybusRListsHttp:
 * A simple async list of model objects with CRUD operations.
 * Model objects should implement IRListItem.
 * Objects are keyed by an ekey property.
 * Full etag support through the etag property.
 */
export const rhybusRListsHttp = () => {
  try {
    return new RListsHttp(fetchProvider, apiPath)
  } catch (error) {
    console.error(`
    Error while fetching the API using endpoint RListsHttp. \n
    fetchProvider:${fetchProvider} \n
    apiPath:${apiPath} \n
    Error:${error}`)    
    throw error
  }
}
